module.exports = __webpack_public_path__ + "static/media/shape_two.67f15a51.png";